import { IAvailableServiceCosts } from '../../../../repositories/billing-tariffs/entities/PublishTerms/AvailableServiceCosts';
import { IAuctionServiceCost } from '../../../../types/reducers/auction';
import { EServiceType } from '../../../../types/reducers/publishTerms';
import { getServiceId } from '../../../../utils/publishTerms';

export function mapAuctionServiceCosts(serviceCosts?: IAvailableServiceCosts[] | null): IAuctionServiceCost[] {
  if (!serviceCosts) {
    return [];
  }

  return serviceCosts.map(serviceCost => {
    const { serviceTypes, cost } = serviceCost;

    const serviceId = getServiceId(serviceTypes);

    return {
      serviceId,
      serviceTypes: serviceTypes as Array<string> as Array<EServiceType>,
      cost: Number(cost),
    };
  });
}
